import React from 'react';
import { useHistory } from 'react-router-dom';
import { Form, DatePicker } from 'antd';
import { PATH } from '../../../routes/Routes';
import { URL_WORKFLOW } from '../../../constance/urls';
import { useTranslation } from 'react-i18next';
import MobileList from '../../common/MobileList';
import { formatComma } from '../../../utils/stringFormat';
import { UserOutlined, TruckOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { HUMAN_DATE_FORMAT, DATE_FORMAT } from '../../../constance/strings';
import dayjs from 'dayjs';


function LogWoodPOMobileList() {
  const { t } = useTranslation();
  const history = useHistory();
  const [form] = Form.useForm();
  const date = Form.useWatch('date', form)
  const formateDate = date ? dayjs(date).format(DATE_FORMAT) : '';
  const tableRef = React.useRef();

  const content = {
    header: {
      icon: <UserOutlined />,
      detail: (item) => item.truck_transaction.truck_company_detail.name,
    },
    descriptions: [
      {
        icon: <TruckOutlined />,
        header: (item) => item.truck_transaction.truck_type_name,
        detail: (item) => `${t('trucks.license_plate')} ${item.truck_transaction.license_plate}`
      },
      {
        icon: <ShoppingCartOutlined />,
        header: (item) => t('truck_transactions.net_weight'),
        detail: (item) => `${formatComma(item.truck_transaction.net_weight)} ${t('units.kilo_gram')}`
      }
    ],
    onClick: (item) => history.push(`${PATH.LOG_WOOD_PO}${item.id}`)
  }


  const dateFilterComponent = (
    <Form form={form}>
      <Form.Item label={t('searchs.fields.date')} layout="vertical" name={'date'} >
        <DatePicker
          allowClear
          layout="vertical"
          style={{ width: '100%' }}
          placeholder={t('searchs.placeholders.date')}
          format={HUMAN_DATE_FORMAT}
        />
      </Form.Item>
    </Form>
  );


  return (
    <div>
      <MobileList
        ref={tableRef}
        fetchUrl={URL_WORKFLOW.LOG_WOOD_PO_WORKFLOW}
        content={content}
        showFilterHeader
        extraFilter={dateFilterComponent}
        extraFilterParams={{ date: formateDate }}
      />
    </div>
  )
}

export default LogWoodPOMobileList;

